var _path, _polygon, _rect, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _polygon2, _rect5, _rect6, _polygon3, _rect7, _rect8, _polygon4, _rect9, _rect10, _polygon5, _rect11, _rect12, _polygon6, _rect13, _rect14, _g, _g2, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPantry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "basic",
    viewBox: "0 0 48 48",
    width: 480,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M8,42V4h16.63v38H8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f5bc00",
    points: "22.384,42 22.384,22 22.384,4 40,4 40,42"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    x: 8,
    y: 40,
    fill: "#f5bc00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M40,42h-6v2h6V42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5bc00",
    d: "M14,42H8v2h6V42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb7900",
    d: "M40,40.008h-6V42h6V40.008z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb7900",
    d: "M14,40.008H8V42h6V40.008z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 31,
    x: 11,
    y: 7,
    fill: "#6c19ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    x: 11,
    y: 16,
    fill: "#f5bc00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 2,
    x: 11,
    y: 27,
    fill: "#f5bc00"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3dd9eb",
    points: "15.833,29.875 14.22,29.875 13.011,31.126 13.011,38 17,38 16.994,31.126"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 13,
    y: 29,
    fill: "#00b3d7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.989,
    height: 2,
    x: 13.011,
    y: 33,
    fill: "#7debf5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3dd9eb",
    points: "33.833,29.875 32.22,29.875 31.011,31.126 31.011,38 35,38 34.994,31.126"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 31,
    y: 29,
    fill: "#00b3d7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.989,
    height: 2,
    x: 31.011,
    y: 33,
    fill: "#7debf5"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3dd9eb",
    points: "27.833,29.875 26.22,29.875 25.011,31.126 25.011,38 29,38 28.994,31.126"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 25,
    y: 29,
    fill: "#00b3d7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.989,
    height: 2,
    x: 25.011,
    y: 33,
    fill: "#7debf5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3dd9eb",
    points: "21.833,29.875 20.22,29.875 19.011,31.126 19.011,38 23,38 22.994,31.126"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 19,
    y: 29,
    fill: "#00b3d7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.989,
    height: 2,
    x: 19.011,
    y: 33,
    fill: "#7debf5"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3dd9eb",
    points: "12.998,11 13.873,10 17.998,10 18.998,11 18.998,16 12.996,16.017"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 6.002,
    height: 5.017,
    x: 12.996,
    y: 11,
    fill: "#fadb00"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 12.998,
    y: 8,
    fill: "#fadb00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3dd9eb",
    points: "21,10.983 21.875,9.983 26,9.983 27,10.983 27,15.983 20.998,16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.002,
    height: 5.017,
    x: 20.998,
    y: 10.983,
    fill: "#eb7900"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 21,
    y: 7.983,
    fill: "#eb7900"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#3dd9eb",
    points: "29,10.983 29.875,9.983 34,9.983 35,10.983 35,15.983 28.998,16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.002,
    height: 5.017,
    x: 28.998,
    y: 10.983,
    fill: "#00b3d7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    x: 29,
    y: 7.983,
    fill: "#00b3d7"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    x: 13,
    y: 20,
    fill: "#a64aff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 7,
    x: 25,
    y: 20,
    fill: "#a64aff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 16,
    y: 22,
    fill: "#6c19ff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    x: 28,
    y: 22,
    fill: "#6c19ff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 8,
    y: 16,
    fill: "#eb7900"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 8,
    y: 27,
    fill: "#eb7900"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 37,
    y: 27,
    fill: "#eb7900"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    x: 37,
    y: 16,
    fill: "#eb7900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantry);
export default __webpack_public_path__ + "static/media/Pantry.49c3871a9abfbaa8ab44312f5c8d5e40.svg";
export { ForwardRef as ReactComponent };